import { memo } from "react";
import classNames from "classnames";
import { AccountCardProps } from "@components/financialAccount/AccountCard/AccountCard";
import { InstitutionIcon } from "@design-system/InstitutionIcon/InstitutionIcon";
import "@components/financialAccount/AccountCard/AccountCard.scss";

export const QuickbooksAccountCard = memo(
    ({ iconSize = "xs" }: { iconSize?: AccountCardProps["iconSize"] }) => (
        <div className="account-card">
            <InstitutionIcon
                institution="quickbooks"
                size={iconSize}
                className={classNames(
                    "account-card__icon",
                    `account-card__icon--${iconSize}`,
                )}
            />
            <div className="account-card__name-type">
                <div className="account-card__name">QuickBooks</div>
            </div>
        </div>
    ),
);
QuickbooksAccountCard.displayName = "QuickbooksAccountCard";
